import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { PhoneLocationSettings } from './PhoneLocationSettings'
import { PhoneNumbers } from './PhoneNumbers'

export const PhoneSpecificSettings = (): ClickNavigationProps[] => {
  return [
    { id: 'phoneNumbers', label: 'Phone Numbers', content: () => <PhoneNumbers /> },
    { id: 'location', label: 'Zocks Contact Card', content: () => <PhoneLocationSettings /> },
  ]
}
